import template from './imageCircle.html';
import controller from './imageCircleCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    type: '@',
    imageSource: '<',
    fullName: '@',
    initials: '@',
    color: '@',
    size: '@',
  },
};
